<template>

  <div v-if="partners.length > 0" id="partners-slider">

    <div class="row mb-3">
      <div class="col-6">
        <h2 v-if="show_title" class="mb-0 text-primary text-center">Nos partenaires</h2>
      </div>
      <div class="col-6 text-right">
        <a v-if="show_button_all" href="/module/dlnkpartners/partners" class="btn btn-pill btn-primary transition-3d-hover">
          Voir tous les partenaires&nbsp;<i class="fas fa-angle-right fa-sm ml-1"></i>
        </a>
      </div>
    </div>

    <div class="card p-3">
      <div id="partners-carousel" class="owl-carousel owl-theme">
        <div class="item" v-for="partner in partners">
          <div>
            <a href="javascript:void(0);" data-toggle='modal' :data-target="'#partner_modal-' + partner.id">
              <img :src="partner.logo"/>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!----Affiche modal ---->
    <div v-for="partner in partners" class="modal" tabindex="-1" role="dialog" :id="'partner_modal-' + partner.id">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <img :src="partner.logo" width="150px"/>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <p class="partenaire_text_modal" v-html="partner.description"></p>
            <a v-if="typeof partner.url !== 'undefined' && partner.url.length > 7" :href="partner.url" target="_blank">En savoir plus</a>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">Fermer</button>
          </div>
        </div>
      </div>
    </div>
    <!--fin affiche modal-------->

  </div>

</template>

<script>

export default {
  props: {
    show_title: {
      type: Boolean,
      default: true
    },
    show_button_all: {
      type: Boolean,
      default: true
    },
    show_nav: {
      type: Boolean,
      default: true
    },

  },

  data: function () {
    return {
      partners: Array,
      partner: Object,
    }
  },

  mounted() {
    this.get_data()
  },

  computed: {},

  methods: {

    get_data: function () {
      const _this = this;

      get_token_2().then(function (response) {
        let [secure_key, customer_id, api_url] = response
        api_url += "/partner_partners.json"
        api_url += '?secure_key=' + secure_key
        api_url += '&customer_id=' + customer_id

        axios.get(api_url)
            .then(function (response) {
              _this.partners = response.data
            })
            .catch(function (error) {
              _this.message = "Erreur";
              _this.message_type = "alert-danger"
            })
            .then(function () {
              $("#partners-carousel").owlCarousel({
                loop: true,
                margin: 40,
                nav: _this.show_nav,
                autoplay: true,
                dots: false,
                responsive: {
                  0: {
                    items: 1,
                    loop: true
                  },
                  600: {
                    items: 3,
                    loop: true
                  },
                  1000: {
                    items: 4,
                    loop: true
                  }
                }
              });

            });
      })
    },
  }
}
</script>

<style scoped>

.bg-blue {
  background-color: #0049a4;
}

</style>